import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import Title from './Title';
import { Wrapper, CloseIconWrapper, CloseIcon, Owned } from './styled';
import CopyLink from 'Common/Components/CopyLink';
import CopyApiLink from 'Common/Components/CopyApiLink';
import { selectCurrentWorkspace, selectReadOnly } from 'store/Faraday/selectors';

const Header = ({ data, owned, serviceId, redirectToService, updateService, entity }) => {
  const dispatch = useDispatch();
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const intl = useIntl();
  const ownedText = owned ? intl.formatMessage({ id: 'host.hostDetail.owned' }) : intl.formatMessage({ id: 'host.hostDetail.notOwned' });
  const servicePath = `ws/${workspaceSelected}/services/${serviceId}`;
  const readOnly = useSelector(selectReadOnly);
  const canUpdate = entity !== 'servicesGeneral' ? !readOnly : true;

  const updateOwned = () => {
    if (canUpdate) updateService(serviceId, { owned: !owned });
  };

  const closeDetail = () => dispatch(redirectToService());

  useModalShortcuts({ id: 'service-detail', onCancel: closeDetail, cancelLabel: 'Close' });

  return (
    <Wrapper>
      <Title serviceDetail={ data } serviceId={ serviceId } updateService={ updateService } entity={ entity } />
      <Owned owned={ owned } onClick={ updateOwned } disabled={ !canUpdate }>{ ownedText }</Owned>
      <CopyLink />
      <CopyApiLink path={ servicePath } />
      <CloseIconWrapper onClick={ closeDetail }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

export default Header;
